import React from "react";
import { styled, tooltipClasses } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    "&::before": {
      boxShadow: theme.shadows[1],
    },
  },
}));

const LightTooltip = ({ title, children, ...rest }) => {
  return (
    <StyledTooltip title={title} {...rest}>
      {children}
    </StyledTooltip>
  );
};

export default LightTooltip;
